import { VariationTypes } from './variationTypes';

type ValueOf<T> = T[keyof T];

export type FeatureFlag = {
  name: string;
  variationType: ValueOf<typeof VariationTypes>;
};

// Names must match the feature flag names in Optimizely
export const FeatureFlags = {
  PACKAGE_QUICK_SELECT: {
    name: 'package_quick_select',
    variationType: VariationTypes.ROLLOUT,
  },
  SHIPMENTS_BULK_SELECTION: {
    name: 'shipments_bulk_selection',
    variationType: VariationTypes.A_B_TESTING,
  },
  SHOW_DUPLICATE_ORDERS: {
    name: 'show_duplicate_orders',
    variationType: VariationTypes.A_B_TESTING,
  },
  NEW_RETURNS_WORKFLOW: {
    name: 'new_returns_workflow',
    variationType: VariationTypes.A_B_TESTING,
  },
  ORDERS_REDESIGN: {
    name: 'orders_redesign',
    variationType: VariationTypes.ROLLOUT,
  },
  ORDERS_REDESIGN_WITH_OPT_IN_OPT_OUT: {
    name: 'orders_redesign_with_opt_in_opt_out',
    variationType: VariationTypes.OPT_IN_OUT,
  },
  INSIGHTS: {
    name: 'insights',
    variationType: VariationTypes.ROLLOUT,
  },
  JOIN_FLOW: {
    name: 'join_flow_2024',
    variationType: VariationTypes.A_B_TESTING,
  },
  ORDER_TAG_MVP: {
    name: 'order_tag_mvp',
    variationType: VariationTypes.ROLLOUT,
  },
  SHOW_PARCEL_BOT: {
    name: 'show_ai_parcel_bot',
    variationType: VariationTypes.ROLLOUT,
  },
  WEBAPP_NEW_RELIC: {
    name: 'webapp_new_relic',
    variationType: VariationTypes.ROLLOUT,
  },
} as const satisfies Record<string, FeatureFlag>;
